<!-- компонент vdsView: просмотр VDS -->
<template>
	<div v-if="this.$store.state.is_auth">
		<template v-if="!form_ErrorMessage">

			<!-- блок с локальным сообщением об ошибке -->
			<transition name="fadeControl" key="transitionError">
				<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
					<button v-show="localErrorMessageButton" @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
					<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessageClear)"></span>
				</div>
			</transition>
			<!-- ===================================== -->

			<!-- Заголовок -->
			<h4 v-if="sslData" class="w5-view-header">{{ sslData.title | ftc }}</h4>
			<!-- ===================================== -->

			<div v-if="sslData" class="ssl-info-block">
				<!-- Status -->
				<template v-if="sslStatus">
					<span v-if="sslStatus['loader']" class="margin-right-10" :class="'w5-status-color-' + clearStatus">{{ sslStatus['status'] | capitalize }} <img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" /></span>
					<span v-else-if="sslStatus['timer']" class="margin-right-10" :class="'w5-status-color-' + clearStatus">{{ sslStatus['status'] | capitalize }} <font-awesome-icon icon="clock" style="margin-left: 6px" /></span>
					<span v-else class="margin-right-10" :class="'w5-status-color-' + clearStatus">{{ sslStatus['status'] | capitalize }}</span>
				</template>
				
				<!-- Дата и срок -->
				<template v-if="sslData && sslData.service && sslData.service.service_end">
					<span class="font-weight-300">{{ sslData.service.service_end.title | ftc }}:</span> &nbsp;<span class="ssl-info-span">{{ formater_StrDateFormat(sslData.service.service_end.value, 'd.m.Y') }}</span>
				</template>
				<!-- ===================================== -->

				<!-- аккаунт, если указан -->
				<template v-if="Account">
					<br/>
					{{ Account.account_id.title | ftc }}:
						<!-- глоб.фильтр -->
						<template v-if="$store.state.user_type === 'admin'">
							<font-awesome-icon v-if="!Account['global_filter'] || Account['global_filter']['value'] != Account['account_id']['value']"
								class="global-filter-button"
								:title="'account/filter' | ftc"
								@click="setAccountGlobalFilter(Account['account_id']['value'])"
								icon="filter"
							/>
							<font-awesome-layers v-if="Account['global_filter'] && Account['global_filter']['value'] == Account['account_id']['value']"
								class="global-filter-button global-filter-button-remove"
								:title="'main/delete ' + localeFtc('main/filter').toLowerCase() | ftc"
								@click="setAccountGlobalFilter()">
								<font-awesome-icon icon="filter" />
								<font-awesome-icon icon="times" />
							</font-awesome-layers>
						</template>
						<!-- сама ссылка -->
						<linkComponent :url="'/account/view/' + Account.account_id.value" :text="Account.account_name.value" />
				</template>

				<!-- данные по сертификату -->
				<div v-if="Data" class="ssl-info-table">
					<div v-for="d in Data" v-if="d" class="ssl-info-table-row">
						<div class="header">{{ Array.isArray(d) ? joinProps(d, 'title') : d.title | ftc }}:</div>
						<div class="value">
							<template v-if="!Array.isArray(d) && d.list">{{ d.list[d.value] | ftc }}</template>
							<template v-else>{{ Array.isArray(d) ? joinProps(d, 'value') : d.value | ftc }}</template>
						</div>
					</div>
				</div>
				<!-- ===================================== -->
				
			</div>

			<!-- автопролонгация -->
			<div v-if="sslData" class="tab-pane-command-wrapper">
				<div v-if="autoProlongHint" class="upper-hint">{{ autoProlongHint | ftc }}</div>
				<div class="control-wrapper">
					<input type="checkbox" class="w5-checkbox-field" v-model="autoProlongValue" style="display: none" />
					<label @click="autoProlongClick" :class="{ 'disable': !Access || clearStatus !== 'active' }" style="display: inline-block; height: 3em; line-height: 3em;">
						{{ 'service/autoprolong' | ftc }}
					</label>
				</div>
				<span v-if="!autoProlongValue" class="warning-message" v-withSafeTags="localeFtc('service/autoprolong_off')"></span>		
			</div>
			<!-- ===================================== -->

			<!-- ВКЛАДКИ -->
			<!-- навигация -->
			<ul v-if="objCSR || objPKEY || objCRT || objCA" class="nav nav-tabs margin-top-20">
				<li v-if="objCSR" :class="{ active: curTab === 'csr'}">
					<a href="#" @click.stop.prevent="curTab = 'csr'">{{ objCSR.title | ftc }}</a>
				</li>
				<li v-if="objPKEY" :class="{ active: curTab === 'pkey'}">
					<a href="#" @click.stop.prevent="curTab = 'pkey'">{{ objPKEY.title | ftc }}</a>
				</li>
				<li v-if="objCRT" :class="{ active: curTab === 'crt'}">
					<a href="#" @click.stop.prevent="curTab = 'crt'">{{ objCRT.title | ftc }}</a>
				</li>
				<li v-if="objCA" :class="{ active: curTab === 'ca'}">
					<a href="#" @click.stop.prevent="curTab = 'ca'">{{ objCA.title | ftc }}</a>
				</li>
			</ul>
			<!-- содержимое -->
			<div class="tab-content">

				<div class="tab-pane certificate-add-info-block" :class="{ 'active': curTab === 'csr'}">
					<pre v-if="objCSR && objCSR.value">{{ objCSR.value }}</pre>
				</div>

				<div class="tab-pane certificate-add-info-block" :class="{ 'active': curTab === 'pkey'}">
					<pre v-if="objPKEY && objPKEY.value">{{ objPKEY.value }}</pre>
				</div>

				<div class="tab-pane certificate-add-info-block" :class="{ 'active': curTab === 'crt'}">
					<pre v-if="objCRT && objCRT.value">{{ objCRT.value }}</pre>
				</div>

				<div class="tab-pane certificate-add-info-block" :class="{ 'active': curTab === 'ca'}">
					<pre v-if="objCA && objCA.value">{{ objCA.value }}</pre>
				</div>

			</div>

		</template>
		<errorAlert v-else :message="form_ErrorMessage" />
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import { EventBus } from '../../bus.js'
import Helper from '@/helper/helper'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'sslView',
	//=========================================================================
	//
	//=========================================================================
	data() {
		return {
			// наименование CRUD
			crud: 'certificate',

			// ID ssl
			id: null,

			// локальное сообщение об ошибке
			localErrorMessage: '',

			// кешированные данные для просмотра
			sslData: null,

			// значение автопролонгации
			autoProlongValue: false,
			autoProlongProcessing: false,

			// вкладки
			curTab: false
		}
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		// если ли доступ к редактированию VDS
		Access() {
			// если есть процесс - сразу закрываем доступ
			if (this.sslData &&
				this.sslData.service &&
				this.sslData['service']['service_status'] &&
				this.sslData['service']['service_status']['text'] &&
				String(this.sslData['service']['service_status']['text']).length)
				return false
			// иначе - права по умолчанию
			return this.isAccess('service/update')
		},
		localErrorMessageClear() {
			if (this.localErrorMessage === undefined ||
				this.localErrorMessage === null ||
				this.localErrorMessage === '')
				return ''
			if (this.localErrorMessage.charAt(0) === 'x') return this.localErrorMessage.substr(1)
			return this.localErrorMessage
		},
		localErrorMessageButton() {
			if (this.localErrorMessage === undefined ||
				this.localErrorMessage === null ||
				this.localErrorMessage === '')
				return false
			if (this.localErrorMessage.charAt(0) === 'x') return false
			return true
		},
		Account() {
			if (this.sslData &&
				this.sslData.account &&
				this.sslData.account.account_id &&
				this.sslData.account.account_name)
				return this.sslData.account

			return null
		},
		SSL() {
			if (this.sslData &&
				this.sslData.service &&
				this.sslData.service.service_data &&
				this.sslData.service.service_data.value &&
				this.sslData.service.service_data.value.cert)
				return this.sslData.service.service_data.value.cert

			return null
		},
		Plan() {
			if (this.sslData &&
				this.sslData.plan &&
				this.sslData.plan.plan_id &&
				this.sslData.plan.plan_name)
				return this.sslData.plan

			return null
		},
		sslStatus() {
			if (this.sslData &&
				this.sslData.service &&
				this.sslData.service.service_status)
				return Helper.cellStatusInView(this.sslData['service']['service_status'])

			return null
		},
		clearStatus() {
			if (this.sslData &&
				this.sslData.service &&
				this.sslData.service.service_status &&
				this.sslData.service.service_status.value)
				return this.sslData.service.service_status.value

			return null
		},
		objCSR() {
			if (this.sslData &&
				this.sslData.service &&
				this.sslData.service.certificate_csr &&
				this.sslData.service.certificate_csr.value)
				return this.sslData.service.certificate_csr

			return null
		},
		objPKEY() {
			if (this.sslData &&
				this.sslData.service &&
				this.sslData.service.certificate_pkey &&
				this.sslData.service.certificate_pkey.value)
				return this.sslData.service.certificate_pkey

			return null
		},
		objCRT() {
			if (this.sslData &&
				this.sslData.service &&
				this.sslData.service.certificate_crt &&
				this.sslData.service.certificate_crt.value)
				return this.sslData.service.certificate_crt

			return null
		},
		objCA() {
			if (this.sslData &&
				this.sslData.service &&
				this.sslData.service.certificate_ca &&
				this.sslData.service.certificate_ca.value)
				return this.sslData.service.certificate_ca

			return null
		},
		Address() {
			if (!this.sslData ||
				!this.sslData.service ||
				!this.sslData.service.service_data ||
				!this.sslData.service.service_data.value ||
				!this.sslData.service.service_data.value.cert)
				return ''

			let _tmp = []
			// country province city
			// org_postcode org_address org_phone
			if (this.sslData.service.service_data.value.cert.country)
				_tmp.push(this.sslData.service.service_data.value.cert.country)
			if (this.sslData.service.service_data.value.cert.province)
				_tmp.push(this.sslData.service.service_data.value.cert.province)
			if (this.sslData.service.service_data.value.cert.city)
				_tmp.push(this.sslData.service.service_data.value.cert.city)

			if (this.sslData.service.service_data.value.cert.org_postcode)
				_tmp.push(this.sslData.service.service_data.value.cert.org_postcode)
			if (this.sslData.service.service_data.value.cert.org_address)
				_tmp.push(this.sslData.service.service_data.value.cert.org_address)
			if (this.sslData.service.service_data.value.cert.org_phone)
				_tmp.push(this.sslData.service.service_data.value.cert.org_phone)

			return _tmp.join(', ')
		},
		Owner() {
			if (this.sslData &&
				this.sslData.service &&
				this.sslData.service.service_data &&
				this.sslData.service.service_data.value &&
				this.sslData.service.service_data.value.cert &&
				this.sslData.service.service_data.value.cert.owner)
				return '«' + this.sslData.service.service_data.value.cert.owner + '»'

			// owner
			return ''
		},
		autoProlongHint() {
			if (this.sslData &&
				this.sslData.service &&
				this.sslData.service.service_autoprolong &&
				this.sslData.service.service_autoprolong.hint)
				return this.sslData.service.service_autoprolong.hint

			return null
		},
		Data() {
			if (this.sslData &&
				this.sslData.data &&
				Object.keys(this.sslData.data).length)
			{
				let _data = []
				for (let _prop in this.sslData.data) if (this.sslData.data.hasOwnProperty(_prop))
				{
					let _val = this.sslData.data[_prop]
					let _idx = parseInt(_val.order)
					if ('order' in _val && 'title' in _val && 'value' in _val)
					{
						if (_data[_idx])
						{
							let _obj = _data[_idx]
							_data[_idx] = []
							_data[_idx].push(_obj)
							_data[_idx].push({
								title: _val.title,
								value: _val.value,
								list: _val.list
							})
						}
						else
						{
							_data[_idx] = {
								title: _val.title,
								value: _val.value,
								list: _val.list
							}
						}
					}
				}

				if (_data.length) return _data
			}

			return null
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// получим ID vds
		this.id = this.$route.params['id']
		if (this.id)
		{
			// теперь можно запросить данные
			this.requestSSLData()
		}
		else
		{
			this.localErrorMessage = this.localeFtc('main/unknown_page')
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
		window.addEventListener('storage', this.onLocalStorageEvent)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)
		window.removeEventListener('storage', this.onLocalStorageEvent)
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// запрос данных для просмотра
		//---------------------------------------------------------------------
		requestSSLData() {
			// еще раз проверим ID
			if (!this.id)
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// теперь точно можно делать запрос
			this.$http.get(this.APIServerUrl + '/service/view/' + this.id).then(
				// успешный ответ
				respons => {
					// получаем ответ
					let _dt = respons && respons.data && typeof respons.data === 'object' ? respons.data : false

					// ответ корректный - запросим план
					if (_dt && _dt['status'] === 'ok' && _dt['plan'] && _dt['plan']['plan_id'] && _dt['plan']['plan_id']['value'])
					{
						// запоминаем данные по SSL
						this.sslData = _dt
						// установка флага автопролонгации
						this.autoProlongValue = this.sslData && this.sslData.service && this.sslData.service.service_autoprolong && this.sslData.service.service_autoprolong.value === true
						// активная вкладка
						if (this.objCSR) this.curTab = 'csr'
						else if (this.objPKEY) this.curTab = 'pkey'
						else if (this.objCRT) this.curTab = 'crt'
						else if (this.objCA) this.curTab = 'ca'
						// передаем данные по цепочке
						return _dt
					}

					// другая ошибка
					this.localErrorMessage = this.formatRequestError(respons)
				},
				// отрицательный ответ
				respons => {
					// ошибка ответа сервера
					this.localErrorMessage = this.formatRequestError(respons)
				}
			)
		},
		//---------------------------------------------------------------------
		// автопролонгация
		//---------------------------------------------------------------------
		autoProlongClick() {
			if (!this.id) return
			// если контрол задизаблен - ничего не делаем
			if (!this.Access || this.clearStatus !== 'active') return
			// если мы в процессе изменения - ничего не делаем
			if (this.autoProlongProcessing) return

			// ставим флаг начала процесса
			this.autoProlongProcessing = true
			// делаем запрос на изменение
			let _url = this.APIServerUrl + '/service/update/' + this.id
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'])
					{
						// данные формы
						let _post = {
							'_csrf': _dt['_csrf']
						}
						_post[_dt['model']] = {
							'autoprolong': !this.autoProlongValue ? 1 : 0
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.autoProlongProcessing = false
								// проверка ответа
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id'])
								{
									// меняем значение
									this.autoProlongValue = !this.autoProlongValue
									// на это всем, никаких рефрешей не нужно,
									// ибо придет пуш, и по нему система сама все обновит
									// а пока просто сообщим
									this.setLocalSuccessMessage('main/updated')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.autoProlongProcessing = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// обнулим флаг процесса
					this.autoProlongProcessing = false
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// обнулим флаг процесса
					this.autoProlongProcessing = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length < 3) return

			// сообщение нужно обработать только если совпадает CRUD
			if (_parts[1] !== this.getRealCrud(this.crud)) return

			// получим ID
			let _id = _parts[2]
			// если не задан ID - ничего не делаем
			if (!_id) return

			// обновляем данные, пришедшие с сервера
			// данные внутри компонента "viewComponent" автоматически
			// обновятся по наблюдателю (watch)
			if (String(_id) === String(this.id)) this.requestSSLData()
		},
		//---------------------------------------------------------------------
		// установка успешного сообщения
		//---------------------------------------------------------------------
		setLocalSuccessMessage(msg) {
			EventBus.$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			})
		},
		//---------------------------------------------------------------------
		// установка/снятие глобального фильтра по аккаунту
		//---------------------------------------------------------------------
		setAccountGlobalFilter(account) {
			// если это не сотрудник
			if (this.$store.state.user_type !== 'admin') return

			// если это установка фильтра
			if (account)
			{
				if (!/\d+/.test(account)) return
				let _accountID = parseInt(account)
				if (isNaN(_accountID) || _accountID < 1) return

				// начинаем установку фильтра - готовим параметры и URL
				let _url = this.APIServerUrl + '/admin/index'
				let _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				}

				// обнуляем флаг в Vuex о наличии глобального фильтра
				this.$store.commit('accountGlobalFilter', false)

				// делаем сам запрос
				this.$http.get(_url, { 'params': _params }).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// стафим флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', true)

							// генерируем событие установки глобального фильтра
							if (window && window.localStorage)
								window.localStorage.setItem('__event', 'agf1' + (new Date()).getTime() + '_' + _accountID)

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							// сообщаем что глобальный фильтр установлен
							this.setLocalSuccessMessage('main/set_filter ' + this.Account['account_name']['value'])

							// тихо рефрешим ВСЮ страницу
							this.requestSSLData()

							// на этом все
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resGet)
					},
					// получили отрицательный ответ сервера
					resGet => {
						this.localErrorMessage = this.formatRequestError(resGet)
					}
				)
			}
			// если это очистка глобального фильтра
			else
			{
				// начинаем очистку фильтра - готовим URL согласно API
				let _url = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter'

				// делаем сам запрос
				this.$http.get(_url).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// обнуляем флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', false)

							// генерируем событие снятия глобального фильтра
							if (window && window.localStorage)
								window.localStorage.setItem('__event', 'agf0' + (new Date()).getTime())

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							// сообщаем что глобальный фильтр установлен
							this.setLocalSuccessMessage(this.localeFtc('main/filter') + ' ' + this.localeFtc('main/deleted').toLowerCase())

							// тихо рефрешим ВСЮ страницу
							this.requestSSLData()

							// на этом все
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resGet)
					},
					// получили отрицательный ответ сервера
					resGet => {
						this.localErrorMessage = this.formatRequestError(resGet)
					}
				)
			}
		},
		//---------------------------------------------------------------------
		//
		//---------------------------------------------------------------------
		joinProps(arr, field)
		{
			let _d = []
			arr.forEach(i => _d.push(i[field]))

			return _d.join(', ')
		},
		//---------------------------------------------------------------------
		// обработчик события "storage"
		//---------------------------------------------------------------------
		onLocalStorageEvent(event) {
			// только для сотрудников
			if (this.$store.state.user_type !== 'admin') return
			// проверка события
			if (!event || event.key !== '__event' || !event.newValue) return

			if (event.newValue.indexOf('agf1') === 0 ||
				event.newValue.indexOf('agf0') === 0)
			{
				// запрос счетчиков
				this.$store.dispatch('getTicketCounters')
				this.$store.dispatch('getRequestCounter')

				// тихо рефрешим ВСЮ страницу
				this.requestSSLData()
			}
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.ssl-info-block {	
	padding-top: 0;
	line-height: 2;
	font-size: 95%;
}

.ssl-info-block > p {
	margin: 10px 0;
	width: 70%;
	font-size: 12px;
	font-weight: 300;
	line-height: 1.4;
}

.ssl-info-span {
	font-weight: 500;
}

.certificate-add-info-block {
	margin: 15px 0;
}

.upper-hint {
	display: table-cell;
    vertical-align: middle;
    font-weight: 300;
    font-size: 13px;
}

.ssl-info-table {
	margin-top: 10px;
	margin-bottom: 20px;
	border: 1px solid #eee;
	border-radius: 4px;
	padding: 10px 15px;
}

.ssl-info-table-row {
	display: table;
	margin: 10px 0;
}

.ssl-info-table-row:first-child {
	margin-top: 5px;
}
.ssl-info-table-row:last-child {
	margin-bottom: 5px;
}

.ssl-info-table-row .header {
	display: table-cell;
	width: 120px;
	line-height: 1.2;
}

.ssl-info-table-row .value {
	display: table-cell;
	font-weight: 500;
	line-height: 1.2;
}
</style>



// WEBPACK FOOTER //
// sslView.vue?3d60a856